import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Helper from '../../utility/helper';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import DataList from './dataList/dataList';
import moment from 'moment';
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};


const ActivityAudit = (props) => {
    const loading = useState(false);
    const transportList = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const allListData = useState([]);
    const allData = useState();
    const fullData = useState([]);
    useEffect(() => {
        getTransportList();
    }, []);

    const getTransportList = () => {
        loading.set(true);
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_TRACKER_AUDIT_DETAILS(
                gEventInfo.eventID
            )
        )
            .then((res) => {
                if (res.data) {
                    let data = res.data;
                    let requestData = [];
                    let allrequestData = [];
                    if (data.length > 0) {
                        data.map((item) => {
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        key: 'abc',
                                        abc: generateAddedRemovedText(item),
                                        width: '10',
                                        inHTML: true
                                    },
                                ],
                                selected: false,
                            });
                        });
                        fullData.set(allrequestData)
                    } else {
                        fullData.set([])
                    }
                    transportList.set(allrequestData);
                    allData.set(requestData);
                    allListData.set(requestData);
                }
                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const generateAddedRemovedText = (item) => {
        var displayText = ``;
        if (item.added != "") {
            displayText = displayTextVal(displayText, item, 'ADDED', item.added);
        }

        if (item.removed != "") {
            displayText = displayText + `<div style="margin-top:${displayText ? '6px' : '0px'}">`;
            displayText = displayTextVal(displayText, item, 'REMOVED', item.removed);
        }
        return displayText;
    }

    const displayTextVal = (displayText, item, action, activityName) => {
        var newDisplayText = ``;
        if (item.userName === item.auditBy) {
            newDisplayText = displayText + `${item.userName} has been <b>${action}</b> ${action === 'ADDED' ? 'TO' : 'FROM'} : <b> ${activityName} </b>ON ${moment(item.auditDate).format("MMMM D, YYYY")} at  ${moment(item.auditDate).format("hh:mm:ss A")}</div>`;
        }
        else {
            newDisplayText = displayText + `${item.auditBy} <b>${action}</b> ${item.userName} ${action === 'ADDED' ? 'TO' : 'FROM'} <b> ${activityName} </b>ON ${moment(item.auditDate).format("MMMM D, YYYY")} at  ${moment(item.auditDate).format("hh:mm:ss A")}</div>`;
        }
        return newDisplayText;
    }

    return (
        <Box sx={{
            width: '100%',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 70px)',
        }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : fullData.get() ? (
                <DataList
                    data={fullData.attach(Downgraded).get()}
                    allData={fullData.attach(Downgraded).get()}
                    searchLabel={'Search'}
                    showSearch={true}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    hideSelectAll={true}
                />
            ) : null}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default ActivityAudit